// src/components/ui/Row.tsx
import React from 'react';

export default function Row({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-2">{children}</div>
  );
}
